module.exports = __webpack_public_path__ + "img/logo-webtraining.7031c16e.png";